import { ToastAlert } from '@/components/alert-message';

export function showSuccessToast(
  showToast: boolean,
  message: string,
  setShowToast: Function
) {
  if (showToast === true) {
    return (
      <ToastAlert
        setShow={setShowToast}
        variant="success"
        message={message}
      ></ToastAlert>
    );
  }
}

export function showErrorToast(
  showToast: boolean,
  message: string,
  setShowToast: Function,
  headers?: string,
  className?: string
) {
  if (showToast === true) {
    return (
      <ToastAlert
        setShow={setShowToast}
        variant="error"
        message={message}
        header={headers}
        className={className}
      ></ToastAlert>
    );
  }
}

export function showWarnToast(
  showToast: boolean,
  message: string,
  setShowToast: Function,
  headers?: string,
  className?: string
) {
  if (showToast === true) {
    return (
      <ToastAlert
        setShow={setShowToast}
        variant="warn"
        message={message}
        header={headers}
        className={className}
      ></ToastAlert>
    );
  }
}
